// /**
//  * custom-product.js
//  * The Betterr — Product Page Custom Logic
//  */

// (function () {

//   const PACK_GRAM_MAP = {
//     Box: ['200', '400'],
//     Sachet: ['150', '300'],
//   };

//   function getSelectedPack(container) {
//     const checked = container.querySelector('input[name^="Pack"]:checked');
//     return checked ? checked.value.trim() : null;
//   }

//   function applyGramFilter(container) {
//     if (!container) return;
//     const selectedPack = getSelectedPack(container);
//     if (!selectedPack) return;

//     const allowedGrams = PACK_GRAM_MAP[selectedPack] || [];
//     const gramInputs = container.querySelectorAll('input[name^="Grams"]');
//     let selectedGramHidden = false;

//     gramInputs.forEach((input) => {
//       const value = input.value.trim();
//       const label = container.querySelector('label[for="' + input.id + '"]');
//       const isAllowed = allowedGrams.includes(value);

//       input.style.display = isAllowed ? '' : 'none';
//       input.disabled = !isAllowed;
//       if (label) label.style.display = isAllowed ? '' : 'none';

//       if (input.checked && !isAllowed) {
//         selectedGramHidden = true;
//         input.checked = false;
//       }
//     });

//     if (selectedGramHidden) {
//       const firstAllowed = container.querySelector('input[name^="Grams"]:not([disabled])');
//       if (firstAllowed) {
//         firstAllowed.checked = true;
//         firstAllowed.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     }
//   }

//   function init() {
//     const container = document.querySelector('variant-selects');
//     if (!container) return;

//     if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

//     // Apply on first load
//     applyGramFilter(container);

//     // 1. Fire immediately when user clicks any option — before fetch starts
//     //    This hides the grams instantly with zero flash
//     subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function ({ data }) {
//       // Only re-filter if the Pack option was changed
//       const changedName = data?.target?.name || '';
//       if (changedName.startsWith('Pack')) {
//         // The clicked input is already checked at this point
//         const clickedValue = data?.target?.value?.trim();
//         if (!clickedValue) return;

//         const allowedGrams = PACK_GRAM_MAP[clickedValue] || [];
//         const gramInputs = container.querySelectorAll('input[name^="Grams"]');
//         let selectedGramHidden = false;

//         gramInputs.forEach((input) => {
//           const value = input.value.trim();
//           const label = container.querySelector('label[for="' + input.id + '"]');
//           const isAllowed = allowedGrams.includes(value);

//           input.style.display = isAllowed ? '' : 'none';
//           input.disabled = !isAllowed;
//           if (label) label.style.display = isAllowed ? '' : 'none';

//           if (input.checked && !isAllowed) {
//             selectedGramHidden = true;
//             input.checked = false;
//           }
//         });

//         if (selectedGramHidden) {
//           const firstAllowed = container.querySelector('input[name^="Grams"]:not([disabled])');
//           if (firstAllowed) {
//             firstAllowed.checked = true;
//             firstAllowed.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         }
//       }
//     });

//     // 2. Re-apply after DOM re-render completes (catches fresh HTML from fetch)
//     subscribe(PUB_SUB_EVENTS.variantChange, function () {
//       applyGramFilter(document.querySelector('variant-selects'));
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

// })();


/**
 * custom-product.js
 * The Betterr — Product Page Custom Logic
 *
 * 1. Sachet/Box variant filtering
 * 2. Variant image set filtering (alt text based)
 */

/**
 * custom-product.js
 * The Betterr — Product Page Custom Logic
 *
 * 1. Sachet/Box variant filtering
 * 2. Variant image set filtering (data-media-alt based, layout-agnostic)
 */

(function () {

  // ─── CONFIG ────────────────────────────────────────────────────────────────

  const PACK_GRAM_MAP = {
    Box: ['200g', '400g'],
    Sachet: ['30 Sachets', '60 Sachets'],
  };

  const ALL_VARIANT_ALTS = ['Box 200g', 'Box 400g', 'Sachet 30 Sachets', 'Sachet 60 Sachets'];

  // ─── VARIANT PICKER FILTER ─────────────────────────────────────────────────

  function getSelectedPack(container) {
    const checked = container.querySelector('input[name^="Pack"]:checked');
    return checked ? checked.value.trim() : null;
  }

  function getSelectedGram(container) {
    const checked = container.querySelector('input[name^="Grams"]:checked');
    return checked ? checked.value.trim() : null;
  }

  function applyGramFilter(container) {
    if (!container) return;
    const selectedPack = getSelectedPack(container);
    if (!selectedPack) return;

    const allowedGrams = PACK_GRAM_MAP[selectedPack] || [];
    const gramInputs = container.querySelectorAll('input[name^="Grams"]');
    let selectedGramHidden = false;

    gramInputs.forEach((input) => {
      const value = input.value.trim();
      const label = container.querySelector('label[for="' + input.id + '"]');
      const isAllowed = allowedGrams.includes(value);

      input.style.display = isAllowed ? '' : 'none';
      input.disabled = !isAllowed;
      if (label) label.style.display = isAllowed ? '' : 'none';

      if (input.checked && !isAllowed) {
        selectedGramHidden = true;
        input.checked = false;
      }
    });

    if (selectedGramHidden) {
      const firstAllowed = container.querySelector('input[name^="Grams"]:not([disabled])');
      if (firstAllowed) {
        firstAllowed.checked = true;
        firstAllowed.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // ─── IMAGE SET FILTER ──────────────────────────────────────────────────────
  // Uses [data-media-alt] stamped by Liquid on every <li>
  // Layout-agnostic — works for stacked, columns, thumbnail, thumbnail_slider
  // No class dependency — switching layouts requires zero JS changes

  function applyImageFilter(pack, gram) {
    if (!pack || !gram) return;
    const targetAlt = pack + ' ' + gram; // e.g. "Box 200"

    document.querySelectorAll('[data-media-alt]').forEach((li) => {
      const alt = (li.dataset.mediaAlt || '').trim();
      const isVariantImage = ALL_VARIANT_ALTS.includes(alt);
      // Show if: matches selected variant OR is a shared image (blank/non-variant alt)
      li.style.display = (!isVariantImage || alt === targetAlt) ? '' : 'none';
    });
  }

  // ─── INIT ──────────────────────────────────────────────────────────────────

  function init() {
    const container = document.querySelector('variant-selects');
    if (!container) return;

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    // Initial apply on page load
    applyGramFilter(container);
    applyImageFilter(getSelectedPack(container), getSelectedGram(container));

    // Immediate on Pack or Gram click — before fetch, zero flash
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function ({ data }) {
      const changedName = data?.target?.name || '';

      if (changedName.startsWith('Pack')) {
        const clickedPack = data?.target?.value?.trim();
        if (!clickedPack) return;

        const allowedGrams = PACK_GRAM_MAP[clickedPack] || [];
        const gramInputs = container.querySelectorAll('input[name^="Grams"]');
        let selectedGramHidden = false;
        let newGram = null;

        gramInputs.forEach((input) => {
          const value = input.value.trim();
          const label = container.querySelector('label[for="' + input.id + '"]');
          const isAllowed = allowedGrams.includes(value);

          input.style.display = isAllowed ? '' : 'none';
          input.disabled = !isAllowed;
          if (label) label.style.display = isAllowed ? '' : 'none';

          if (input.checked && !isAllowed) {
            selectedGramHidden = true;
            input.checked = false;
          }
        });

        if (selectedGramHidden) {
          const firstAllowed = container.querySelector('input[name^="Grams"]:not([disabled])');
          if (firstAllowed) {
            newGram = firstAllowed.value.trim();
            firstAllowed.checked = true;
            firstAllowed.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          const currentGram = container.querySelector('input[name^="Grams"]:checked');
          newGram = currentGram ? currentGram.value.trim() : null;
        }

        applyImageFilter(clickedPack, newGram);
      }

      if (changedName.startsWith('Grams')) {
        const clickedGram = data?.target?.value?.trim();
        const currentPack = getSelectedPack(container);
        applyImageFilter(currentPack, clickedGram);
      }
    });

    // After DOM re-render — re-apply on fresh HTML
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      const freshContainer = document.querySelector('variant-selects');
      applyGramFilter(freshContainer);
      applyImageFilter(getSelectedPack(freshContainer), getSelectedGram(freshContainer));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();